<template>
  <div class="mx-sm-1 mt-0">
    <div class="page-header">
      <h1 class="page-title fw-bold">{{ $t('project.title') }}</h1>
    </div>
    <ProjectForm createMode />
  </div>

</template>

<script>
  import ProjectForm from './ProjectForm.vue';

  export default {
    name: 'ProjectCreate',
    components: { ProjectForm },
  };
</script>
